<!-- <h1 mat-dialog-title align="center">Alert</h1> -->
<div mat-dialog-content>{{data.message}}</div>
<div mat-dialog-actions align="end">
    <button mat-raised-button color="primary" mat-dialog-close>Ok</button>
</div>